import { CurrencyInfo } from './currency-info';

export interface PlayerBalance {
    id: number;
    currency: number;
    availableMoney: number;
    onTable: number;
    points: number;
    bonus: number;
    cashToken: number;
    cashDollarAvailable?: number;
    cashDollarOnTable?: number;
    cashDollarOnTables?: { [tableId: number]: number };
}

export function getCashDollarAvailable(balance?: PlayerBalance | null): number {
    return balance?.cashDollarAvailable || 0;
}

export function getCashGameAvailable(balance?: PlayerBalance | null): number {
    return (balance?.availableMoney || 0) + getCashDollarAvailable(balance);
}

export function getOnTablesTotal(balance?: PlayerBalance | null): number {
    return (balance?.onTable || 0) + (balance?.cashDollarOnTable || 0);
}

export function getCashDollarOnTable(
    balance?: PlayerBalance | null,
    tableId?: number,
): number {
    if (!balance) {
        return 0;
    }
    if (tableId != null && balance.cashDollarOnTables) {
        return balance.cashDollarOnTables[tableId] || 0;
    }
    return balance.cashDollarOnTable || 0;
}

export function formatCashDollarNumber(
    value: number,
    currency?: CurrencyInfo | null,
): string {
    if (value == null || !isFinite(Number(value))) {
        return '';
    }
    const decimals = currency?.NbDecimalVisible ?? 2;
    const divided = Number(value) / (currency?.Multiplier || 1);
    return divided.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}

export function formatCashDollarAmount(
    value: number,
    currency?: CurrencyInfo | null,
    amountOnly = false,
): string {
    const num = formatCashDollarNumber(value, currency);
    if (!num || amountOnly) {
        return num;
    }
    const label = `C${currency?.Symbol || ''}`;
    return `${label} ${num}`;
}
